import { actions } from './district/actions'
import { getters } from './district/getters'
import { state } from './district/state'
import { mutations } from './district/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
